class State {
    state = {};

    get(key, def = null) {
        return this.state[this._key(key)] ?? def;
    }

    put(key, val) {
        this.state[this._key(key)] = val;
    }

    putAll(data) {
        for (const key in data) {
            this.put(key, data[key]);
        }
    }

    putIfNotExists(key, val) {
        if (this.get(key) !== null) {
            return;
        }

        this.put(key, val);
    }

    remove(key) {
        this.state[this._key(key)] = undefined;
    }

    flush() {
        this.state = null;
        this.state = {};
    }

    _key(key) {
        return Array.isArray(key) ? key.join('-') : key;
    }
}

export default new State();
